import { FC } from "react";
import { MdOutlineDescription } from "react-icons/md";
import { RichTextLoading } from "src/components";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";
import { useTranslation } from "react-i18next";

const TermsBarWeb: FC<{ terms: string; loading?: boolean }> = ({ terms, loading }) => {
  const { t } = useTranslation();
  if (!loading && !terms) return null;

  return (
    <div className="flex w-full flex-col">
      <div className="border-border-subtle text-font-default flex items-center gap-3 border-b p-4 text-sm font-semibold">
        <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
          <MdOutlineDescription className="h-5 w-5" />
        </div>
        {t("PointsExchange.exchange.termsAndConditions")}
      </div>
      <div className="px-3 py-2">{loading ? <RichTextLoading /> : <GiftcardHtml className="text-font-default flex flex-col gap-2 text-xs p-2" html={terms} />}</div>
    </div>
  );
};

export default TermsBarWeb;
